import { hits, configure, stats } from 'instantsearch.js/es/widgets';
import { connectStats } from 'instantsearch.js/es/connectors';
import BaseComponent from 'scripts/BaseComponent.js';
import GlobalAutocompleteSearchInstance from '../autocomplete-search';

export default class AutocompleteSearchProductHits extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.name = 'AutocompleteSearchProductHits';

    this.refs = {
      container: '.js-searchProductHits',
      statsContainer: '.js-searchStatsContainer',
    };

    this.dom = {
      $component: component,
      $container: this.$get(this.refs.container),
      $statsContainer: this.$get(this.refs.statsContainer),
    };

    this.state = {
      desktopBreakpoint: '(min-width: 1024px)',
      isEmptyClass: 'is-empty',
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.addProductHits();
  }

  addProductHits() {
    const { dom } = this;

    const emptyCustomStats = connectStats(this.setEmptyStats.bind(this));

    GlobalAutocompleteSearchInstance.search.addWidgets([
      configure({
        hitsPerPage: this.getHitLimit(),
      }),
      hits({
        container: dom.$container,
        templates: {
          item: this.getHitCard.bind(this),
        },
        cssClasses: {
          list: [`${this.name}__list`],
          item: [`${this.name}__item`],
        },
        transformItems: this.transformPrice,
      }),
      stats({
        container: dom.$statsContainer,
        templates: {
          text: this.getStatusWidget.bind(this),
        },
        cssClasses: {
          root: `${this.name}__stats`,
          text: [`${this.name}__stats-text`],
        },
      }),
      emptyCustomStats(),
    ]);
  }

  getHitLimit() {
    const { state: { desktopBreakpoint } } = this;
    const isDesktop = window.matchMedia(desktopBreakpoint).matches;

    return isDesktop ? 8 : 4;
  }

  transformPrice(items) {
    return items.map((entry) => {
      entry.price *= 100;
      return entry;
    });
  }

  setEmptyStats({ nbHits }) {
    const { dom, state } = this;

    if (nbHits === 0) {
      dom.$component.classList.add(state.isEmptyClass);
    } else {
      dom.$component.classList.remove(state.isEmptyClass);
    }
  }

  getHitCard(hit) {
    return `
      <article class="${this.name}__product">
        <a
          class="${this.name}__link"
          href="/products/${hit.handle}?variant=${hit.objectID}"
        >
          ${this.getHitImage(hit.image)}
          ${this.getHitInfo(hit)}
        </a>
      </article>
    `;
  }

  getHitImage(image) {
    return `
      <div class="${this.name}__image-wrap">
        <img
          class="${this.name}__image"
          src="${image}&width=100"
          loading="lazy"
        >
      </div>
    `;
  }

  getHitInfo(hit) {
    return `
      <div class="${this.name}__info-wrap">
        <div class="${this.name}__item-title body">
          ${hit.title}
        </div>

        <div class="${this.name}__info">
          ${this.getHitSelectedOption(hit)}
          ${this.getHitPrice(hit.price)}
        </div>
      </div>
    `;
  }

  getHitSelectedOption(hit) {
    if (!hit.option1 && !hit.option2) return '';

    return `
      <div class="${this.name}__selected-option caption">
        ${hit.option2 || hit.option1}
      </div>
    `;
  }

  getHitPrice(price) {
    return `
      <div class="${this.name}__price caption">
        ${window.Shopify.formatMoney(price).replace('.00', '')}
      </div>
    `;
  }

  getStatusWidget({ nbHits, query }) {
    return `
      <a
        class="${this.name}__cta cta cta--black"
        href="/search?shopify_products%5Bquery%5D=${query}"
      >
        View all ${nbHits} products
      </a>
    `;
  }
}
